import { ShowerQuestion } from './bridal-shower-questions.model';

/**
 * The ten questions, verbatim. The mix of "my/me" and "she/her" is intentional —
 * they are the bride's own wording. Do not normalise it.
 */
export const SHOWER_QUESTIONS: ShowerQuestion[] = [
  { id: 1, question: "What was Emmalyn's first job?", videoUrl: 'assets/video/bridal-shower/q01.mp4' },
  { id: 2, question: 'What is the best dish she cooks?', videoUrl: 'assets/video/bridal-shower/q02.mp4' },
  { id: 3, question: "What is one thing she can't live without?", videoUrl: 'assets/video/bridal-shower/q03.mp4' },
  { id: 4, question: 'What is her favorite TV show?', videoUrl: 'assets/video/bridal-shower/q04.mp4' },
  { id: 5, question: 'What is her ideal date?', videoUrl: 'assets/video/bridal-shower/q05.mp4' },
  { id: 6, question: 'What is her biggest pet peeve?', videoUrl: 'assets/video/bridal-shower/q06.mp4' },
  { id: 7, question: 'What is her favorite vacation destination?', videoUrl: 'assets/video/bridal-shower/q07.mp4' },
  { id: 8, question: 'What is her dream job?', videoUrl: 'assets/video/bridal-shower/q08.mp4' },
  { id: 9, question: 'Who is her favorite music artist?', videoUrl: 'assets/video/bridal-shower/q09.mp4' },
  { id: 10, question: 'What is her favorite thing about me?', videoUrl: 'assets/video/bridal-shower/q10.mp4' },
];

/**
 * Held back until all ten have been played, then dealt into the grid as a
 * surprise eleventh card.
 */
export const BONUS_QUESTION: ShowerQuestion = {
  id: 11,
  question: 'How long did it take for Stephen to make these videos for Josellin?',
  videoUrl: 'assets/video/bridal-shower/bonus.mp4',
};
